import { useRouter } from 'next/router';
import React from 'react';
// @mui
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Stack,
} from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';
import Image from '../../../components/Image';
// routes
import { PATH_SETTINGS } from '../../../routes/paths';


// ----------------------------------------------------------------------

export default function MatchingTipDialog({ open, closeDialog }) {
  const smUp = useResponsive('up', 'sm');
  const router = useRouter();

  function DialogTitleWithCloseButton(props) {
    const { children, closeDialog } = props;

    return (
      <DialogTitle sx={{ mb: 1, px: { xs: 3, sm: 4 }, pt: { xs: 3, sm: 4 }, pb: 0, mr: 4 }}>
        {children}
        {closeDialog ? (
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            edge="end"
            sx={{
              position: 'absolute',
              right: { xs: 18, sm : 24 },
              top: { xs: 18, sm : 24 },
              color: "text.secondary",
            }}
          >
            <Iconify icon={'eva:close-fill'} />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  return (
    <Dialog open={open} onClose={closeDialog} maxWidth="sm">
      <DialogTitleWithCloseButton closeDialog={closeDialog}>
        회사에 어필하는 프로필 작성하면,{!smUp && <br />} 매칭을 더 많이 받을 수 있어요.
      </DialogTitleWithCloseButton>
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, pt: 0 }}>
        <Typography sx={{ mb: 3 }}>
          매칭 확률을 높이는 프로필 작성법과{!smUp && <br />} 계약 성사율을 높이는 미팅 팁을 확인하세요.
        </Typography>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <Stack
            sx={{
              p: 3,
              width: 1,
              borderRadius: 2,
              border: (theme) => `1px solid ${theme.palette.grey[500_32]}`,
              "&:hover": { borderColor: "grey.500", cursor: "pointer" },
              "&:active": { borderColor: "grey.700" }
            }}
            onClick={() => window.open("https://dio.oopy.io/15ea8b46-657c-80b7-a045-c163044b8023", "_blank", "noopener,noreferrer")}
            spacing={0.5}
          >
            {smUp ? (
            <Image
              sx={{ height: 110 }}
              alt="tip-1"
              src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3.png"
              srcSet="
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3.png 1x,
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3_2x.png 2x,
              "
            />
            ) : (
            <Image
              sx={{ height: 110 }}
              alt="tip-1"
              src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3_xs.png"
              srcSet="
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3_xs.png 1x,
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image3_xs_2x.png 2x,
              "
            />
            )}
            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
              <Typography variant="subtitle1">
                프로필 작성 팁 보기
              </Typography>
              <Iconify icon="eva:arrow-ios-forward-fill" sx={{ width: 24, height: 24, color: "text.primary" }} />
            </Stack>
          </Stack>
          <Stack
            sx={{
              p: 3,
              width: 1,
              borderRadius: 2,
              border: (theme) => `1px solid ${theme.palette.grey[500_32]}`,
              "&:hover": { borderColor: "grey.500", cursor: "pointer" },
              "&:active": { borderColor: "grey.700" }
            }}
            onClick={() => window.open("https://dio.oopy.io/15ea8b46-657c-80ae-b1e6-ca561006bbaa", "_blank", "noopener,noreferrer")}
            spacing={0.5}
          >
            {smUp ? (
            <Image
              sx={{ height: 110 }}
              alt="tip-1"
              src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1.png"
              srcSet="
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1.png 1x,
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1_2x.png 2x,
              "
            />
            ) : (
            <Image
              sx={{ height: 110 }}
              alt="tip-1"
              src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1_xs.png"
              srcSet="
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1_xs.png 1x,
                https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/crewtip/crew_tip_image1_xs_2x.png 2x,
              "
            />
            )}
            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
              <Typography variant="subtitle1">
                미팅 팁 보기
              </Typography>
              <Iconify icon="eva:arrow-ios-forward-fill" sx={{ width: 24, height: 24, color: "text.primary" }} />
            </Stack>
          </Stack>
        </Stack>
        <Stack sx={{ mt: 2 }} direction="row" justifyContent="flex-start">
          <Button
            sx={{ color: "text.secondary"}}
            onClick={() => router.push(PATH_SETTINGS.root)}
            startIcon={<SvgIconStyle src="/icons/icon-setting-mono.svg" sx={{ width: 16, height: 16 }} />}
          >
            프로필 개선하러 가기
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
